<template>
    <div class="consult-date">
        <div class="head">
            <div
                class="arrow"
                @click="changeDate(1)"
                :class="{ disabled: activeDisable(1) }"
            >
                <van-icon name="arrow-left" />
            </div>
            <div class="time">
                {{ date | dateFormat('YYYY-MM') }}
            </div>
            <div
                class="arrow"
                @click="changeDate(2)"
                :class="{ disabled: activeDisable(2) }"
            >
                <van-icon name="arrow" />
            </div>
        </div>
        <table class="date-table">
            <colgroup>
                <col class="col" v-for="item in weeks" />
            </colgroup>
            <thead class="thead">
                <tr>
                    <th
                        class="header"
                        v-for="(item, index) in weeks"
                        :key="index"
                    >
                        <div class="inner">
                            <span>{{ item }}</span>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody class="tbody">
                <tr v-for="index in columns">
                    <td
                        v-for="subIndex in [0, 1, 2, 3, 4, 5, 6]"
                        :class="getClass(days, index * 7 + subIndex)"
                    >
                        <div class="inner date">
                            <span>
                                {{
                                    days[index * 7 + subIndex]
                                        | dateFormat('DD')
                                }}
                            </span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from 'moment';
import Vue from 'vue';
import { Icon } from 'vant';
import { Toast } from 'vant';
Vue.use(Icon).use(Toast);

import api_doctor from '@/services/doctor';

export default {
    name: 'consult-date',
    data() {
        return {
            doctorId: null,
            rang: [null, null],
            date: moment(),
            days: [],
            selects: [],
            total: 35, // 7*5
            weeks: ['日', '一', '二', '三', '四', '五', '六'],
        };
    },
    filters: {
        dateFormat(value, format = 'YYYY-MM-DD') {
            return moment(value).format(format);
        },
    },
    computed: {
        columns() {
            if (this.total == 42) {
                return [0, 1, 2, 3, 4, 5];
            } else {
                return [0, 1, 2, 3, 4];
            }
        },
    },
    created() {
        this.doctorId = this.$route.query.doctorId;
        this.initDate();
    },
    mounted() {
        this.loadData();
    },
    methods: {
        initDate() {
            this.days = this.getDays(this.date);
            this.rang[0] = moment().subtract(1, 'M');
            this.rang[1] = moment().add(2, 'M');
        },
        loadData() {
            api_doctor
                .queryDoctorCalendar(
                    this.doctorId,
                    moment(this.date).format('YYYY-MM')
                )
                .then((res) => {
                    let { data = [] } = res.data;

                    let result = data.map((item) => item.date);
                    this.selects = result;
                });
        },
        activeDisable(type) {
            switch (type) {
                case 1:
                    return moment(this.rang[0]).isSame(this.date, 'M');
                case 2:
                    return moment(this.rang[1]).isSame(this.date, 'M');
            }
        },
        getDays(date) {
            var tDate = moment(date).startOf('M');
            this.total = tDate.day() + tDate.daysInMonth() > 35 ? 42 : 35;
            tDate.subtract(tDate.day(), 'd');

            var days = [];
            for (var i = 0; i < this.total; i++) {
                days.push(moment(tDate).add(i, 'd'));
            }
            return days;
        },
        getClass(days, index) {
            var day = days[index];
            let classs = [];

            if (day.isBefore(this.date, 'M')) {
                classs.push('last-month-cell');
            } else if (day.isAfter(this.date, 'M')) {
                classs.push('next-month-btn-day');
            }
            this.selects.forEach((item) => {
                if (day.isSame(item, 'day')) {
                    classs.push('selected-day');
                }
            });
            return classs.join(' ');
        },
        changeDate(type) {
            let disable = this.activeDisable(type);
            if (disable) {
                Toast('只能查看两个月的记录哟~');
                return;
            }

            switch (type) {
                case 1:
                    this.date.subtract(1, 'M');
                    break;
                case 2:
                    this.date.add(1, 'M');
                    break;
            }
            this.initDate();
            this.loadData();
        },
    },
};
</script>

<style lang="less">
.consult-date {
    height: 100vh;
    padding: 0 15px;
    background: white;
    .head {
        height: 58px;
        font-size: 16px;
        font-weight: bold;
        border-bottom: 1px solid rgba(227, 227, 227, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        .time {
            width: 120px;
            display: flex;
            justify-content: center;
        }
        .arrow {
            padding: 8px 8px;
            &.disabled {
                color: #f5f5f5;
            }
        }
    }
    .date-table {
        width: 100%;
        table-layout: fixed;
        th,
        td {
            text-align: center;
            box-sizing: border-box;
            .inner {
                min-height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        th {
            color: #595959;
        }
        td {
            font-size: 16px;
            &.last-month-cell,
            &.next-month-btn-day {
                color: rgba(0, 0, 0, 0.25);
            }
            &.selected-day {
                .inner span {
                    font-size: 14px;
                    display: inline-block;
                    width: 24px;
                    height: 24px;
                    line-height: 24px;
                    text-align: center;
                    border-radius: 50%;
                    background: #208fe3;
                    color: white;
                }
            }
        }
    }
}
</style>